import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ClearEvent } from '../../../actions/app';
import ModalDialog from '../../../components/dialogs/ModalDialog';
import { isCompletePackage } from '../../../utils/package';

function NavigationController({
    confirmedPackage,
    selectedPackage,
    confirmedHotel,
    confirmedDinner,
    confirmedFood,
    food,
    optionalHotel,
    withoutHotel,
    requireDinner,
}) {
    const [warningDialogIsVisible, setWarningDialogIsVisible] = useState(false);
    const [clickedLink, setClickedLink] = useState('');

    const dispatch = useDispatch();

    useEffect(
        () => {
            const hasCompletedPackage = isCompletePackage(
                confirmedPackage != null,
                food != null,
                confirmedFood != null,
                optionalHotel,
                withoutHotel,
                confirmedHotel != null,
                requireDinner,
                confirmedDinner != null,
            );

            if (selectedPackage == null || hasCompletedPackage) {
                return;
            }

            function onClick(e) {
                const link = e.target.closest('a');

                if (link) {
                    e.preventDefault();

                    setWarningDialogIsVisible(true);
                    setClickedLink(link.href);
                }
            }

            const exceptions = ['#', 'tel:', 'mailto:'];
            const allAnchors = [...document.querySelectorAll('a[href]')];
            const applicableAnchors = [];
            for (let i = 0, l = allAnchors.length, a; i < l; ++i) {
                a = allAnchors[i];

                if (
                    a.target === '_blank' ||
                    exceptions.some(e => a.href.indexOf(e) > -1)
                ) {
                    continue;
                }

                a.addEventListener('click', onClick);

                applicableAnchors.push(a);
            }

            return () => {
                applicableAnchors.forEach(a => a.removeEventListener(
                    'click',
                    onClick,
                ));
            };
        },
        [
            confirmedPackage,
            selectedPackage,
            confirmedHotel,
            confirmedDinner,
            confirmedFood,
            food,
            optionalHotel,
            withoutHotel,
            requireDinner,
            clickedLink,
        ],
    );

    function onContinue() {
        const openBurgerMenu = document.querySelector('.burger--open');
        if (typeof (openBurgerMenu) != 'undefined' && openBurgerMenu != null) {
            openBurgerMenu.click();
        }

        setWarningDialogIsVisible(false);
    }

    function onLeave() {
        dispatch(ClearEvent());

        window.location = clickedLink;
    }

    return (
        <ModalDialog
            visible={warningDialogIsVisible}
            type={'leave'}
            primaryAction={onContinue}
            secondaryAction={onLeave}
            modalHeader={'Du är på väg att lämna sidan'}
            modalBody={'Du har just nu en aktiv bokning. Om du väljer att lämna sidan kommer din bokning att försvinna.'}
            ctaButtonText={'Fortsätt med bokningen'}
            secondaryButtonText={'Lämna sidan'}
            hideX={true}
        />
    );
}

export { NavigationController };
